import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/crae-brain',
  component: Layout,
  name: 'CraeBrain',
  meta: {
    title: 'CRAE大脑',
    icon: 'i-ant-design:database-outlined',
    auth: [
      'crae-brain:dashboard:list',
      'crae-brain:memory-assistance:manage',
      'crae-brain:task:list',
      'crae-brain:classification-record:list',
      'crae-brain:model-config:list',
      'crae-brain:tenant-config:list',
      'crae-brain:points:list',
    ],
  },
  children: [
    {
      path: 'memory-assistance',
      name: 'CraeBrainMemoryAssistance',
      component: () => import('@/views/crae-brain/dashboard/index.vue'),
      meta: {
        title: 'Brain记忆协助',
        icon: 'i-ant-design:profile-outlined',
        auth: 'crae-brain:memory-assistance:manage',
      },
    },
    {
      path: 'memory-assistance/:tenantId/memories',
      name: 'CraeBrainMemoryAssistanceMemories',
      component: () => import('@/views/crae-brain/dashboard/memories.vue'),
      meta: {
        title: 'Brain正式记忆',
        auth: 'crae-brain:memory-assistance:manage',
        menu: false,
        activeMenu: '/crae-brain/memory-assistance',
        tabMerge: 'activeMenu',
      },
    },
    {
      path: 'dashboard',
      redirect: '/crae-brain/memory-assistance',
      meta: {
        title: 'Brain记忆协助',
        auth: 'crae-brain:memory-assistance:manage',
        menu: false,
      },
    },
    {
      path: 'tools',
      name: 'CraeBrainToolList',
      component: () => import('@/views/crae-brain/tools/index.vue'),
      meta: {
        title: '工具列表',
        icon: 'i-ant-design:tool-outlined',
        auth: 'crae-brain:dashboard:list',
      },
    },
    {
      path: 'tasks',
      name: 'CraeBrainTaskList',
      component: () => import('@/views/crae-brain/tasks/index.vue'),
      meta: {
        title: '任务列表',
        icon: 'i-ant-design:unordered-list-outlined',
        auth: 'crae-brain:task:list',
      },
    },
    {
      path: 'classification-records',
      name: 'CraeBrainClassificationRecordList',
      component: () => import('@/views/crae-brain/classification-records/index.vue'),
      meta: {
        title: '分类记录',
        icon: 'i-ant-design:partition-outlined',
        auth: 'crae-brain:classification-record:list',
      },
    },
    {
      path: 'model-configs',
      name: 'CraeBrainModelConfig',
      component: () => import('@/views/crae-brain/model-configs/index.vue'),
      meta: {
        title: '模型配置',
        icon: 'i-ant-design:api-outlined',
        auth: ['crae-brain:model-config:list', 'crae-brain:tenant-config:list'],
      },
    },
    {
      path: 'brains',
      name: 'CraeBrainManagement',
      component: () => import('@/views/crae-brain/brains/index.vue'),
      meta: {
        title: 'Brain管理',
        icon: 'i-ant-design:deployment-unit-outlined',
        auth: 'crae-brain:tenant-config:list',
      },
    },
    {
      path: 'tenants',
      name: 'CraeBrainTenantConfig',
      component: () => import('@/views/crae-brain/tenants/index.vue'),
      meta: {
        title: '租户配置',
        icon: 'i-ant-design:setting-outlined',
        auth: 'crae-brain:tenant-config:list',
      },
    },
    {
      path: 'concurrency',
      name: 'CraeBrainConcurrency',
      component: () => import('@/views/crae-brain/concurrency/index.vue'),
      meta: {
        title: '并发管理',
        icon: 'i-ant-design:line-chart-outlined',
        auth: 'crae-brain:tenant-config:list',
        cache: false,
      },
    },
    {
      path: 'points',
      name: 'CraeBrainPoints',
      component: () => import('@/views/crae-brain/points/index.vue'),
      meta: {
        title: '租户积分',
        icon: 'i-ant-design:fund-outlined',
        auth: 'crae-brain:points:list',
      },
    },
    {
      path: 'prompts',
      name: 'CraeBrainPromptConfig',
      component: () => import('@/views/crae-brain/prompts/index.vue'),
      meta: {
        title: '系统提示词',
        icon: 'i-ant-design:file-markdown-outlined',
        auth: 'crae-brain:tenant-config:list',
      },
    },
    {
      path: 'task-prompts',
      name: 'CraeBrainTaskPromptConfig',
      component: () => import('@/views/crae-brain/task-prompts/index.vue'),
      meta: {
        title: '任务提示词',
        icon: 'i-ant-design:message-outlined',
        auth: 'crae-brain:tenant-config:list',
      },
    },
  ],
}

export default routes
